<header><app-nav></app-nav></header>
<main><router-outlet></router-outlet></main>